export {}

const commentSections = document.querySelectorAll<HTMLElement>(".s-comment")

commentSections.forEach(section => {
  const comments = section.querySelectorAll<HTMLElement>(".i-comment")
  const form = section.querySelector<HTMLElement>(".f-comment")

  if (!form) return

  const replyIdInput = form.querySelector<HTMLInputElement>(".f-comment__reply-id")
  const replyMsgWrapper = form.querySelector<HTMLElement>(".f-comment__reply")
  const replyMsg = replyMsgWrapper?.querySelector<HTMLElement>(".f-comment__reply-msg")
  const replyCancelReply = form.querySelector<HTMLElement>(".f-comment__cancel-reply")
  const sortSelect = section.querySelector<HTMLSelectElement>(".s-comment__sort select")

  sortSelect?.addEventListener("change", () => {
    const sort = sortSelect.selectedOptions[0]?.dataset.sortBy
    section.querySelector(".g-comment")?.classList.toggle("--reverse", sort == "DESC")
  })

  replyCancelReply?.addEventListener("click", () => {
    if (replyIdInput) replyIdInput.value = ""
    if (replyMsgWrapper) {
      if (replyMsg) replyMsg.innerHTML = ""
      replyMsgWrapper.classList.remove("--show")
    }
  })

  comments.forEach(comment => {
    const id = comment.id
    if (!id) return

    const replyButton = comment.querySelector(".i-comment__reply-button")
    const commentMessage = comment.querySelector(".i-comment__content")?.innerHTML

    replyButton?.addEventListener("click", () => {
      if (replyIdInput) replyIdInput.value = id
      if (replyMsgWrapper && commentMessage) {
        if (replyMsg) replyMsg.innerHTML = commentMessage
        replyMsgWrapper.classList.add("--show")
      }
      form.scrollIntoView({behavior: "smooth", block: "end"})
    })
  })
})
